import { InputNumber } from 'antd'

import type { InputType } from './input-type'
import { useInputTypeConfig } from './use-input-type-config'

interface AccountInputProps {
  title: string
  value: number | null
  onChange?: (value: number) => void
  type: InputType
  isValid?: boolean
}

const AccountInput = ({ title, value, onChange, type, isValid }: AccountInputProps) => {
  const { precision, editStep, formatter, parser } = useInputTypeConfig(type)

  return (
    <div className="mg-channels-account-card-field">
      <div className="mg-channels-account-card-field-title vp-body-s">{title}</div>
      <InputNumber<number>
        className="mg-channels-account-card-field-input"
        value={value}
        onChange={newValue => {
          onChange?.(newValue ?? 0)
        }}
        precision={precision}
        step={editStep}
        formatter={formatter}
        parser={parser}
        status={isValid === false ? 'error' : undefined}
      />
    </div>
  )
}

export default AccountInput
